import { render, staticRenderFns } from "./ClientAddress.vue?vue&type=template&id=e7f22340&scoped=true"
import script from "./ClientAddress.vue?vue&type=script&lang=js"
export * from "./ClientAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f22340",
  null
  
)

export default component.exports